export const PAYMENT_KEYS = {
  LINE_PAY_OFFLINE: 'linepay-offline',
}

export const PAYMENT_PRESETS = {
  LINE_PAY_OFFLINE: {
    key: PAYMENT_KEYS.LINE_PAY_OFFLINE,
    name: 'LINE Pay',
    gateway: 'linepay',
  },
}

export default {
  PAYMENT_KEYS,
  PAYMENT_PRESETS,
}
